import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getKupon = 'kupon';
const postKuponUrl = 'kupon';
const putKupon = 'kupon/';
const deleteKupon = 'kupon/';

class KuponService {
    getKupon(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getKupon + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }

    postKupon(formData) {
        return axios
            .post(
                API_URL + postKuponUrl,
                formData,
                { headers: authHeader() }
            )
    }

    putKupon(formData) {
        var headers = authHeader();
        return axios
            .put(
                API_URL + putKupon + formData.idKupon, formData,
                { headers: authHeader() }
            )
    }

    deleteKupon(idKupon) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKupon + idKupon,
                { headers: authHeader() }
            )
    }

}

export default new KuponService();